// extracted by mini-css-extract-plugin
module.exports = {"dfp":"Ad__dfp_2wWe7","ad":"Ad__ad_43-8y","bnr":"Ad__bnr_1DqaY","rect":"Ad__rect_1G5KX"};